module.exports = __webpack_public_path__ + "img/icon11.76c01b0.png";